import { call, put, takeLatest } from 'redux-saga/effects';
import Api from '../api';
import _ from 'lodash';


function* listDocs( action )
{
    try
    {
        const opts = action.opts;

        const list = yield call(
            Api.listDocs,
            _.get( opts, 'packageFilter', null ),
            _.get( opts, 'type', null ),
            _.get( opts, 'channel', null ),
            _.get( opts, 'signature', null )
        );

        yield put( { type: 'DOC_LIST_SUCCEEDED', list : list } );
    }
    catch( e )
    {
        console.error( e );
        yield put( { type: 'DOC_LIST_FAILED', message: e.message } );
    }
}


function* mySaga()
{
    yield takeLatest( 'DOC_LIST_REQUESTED', listDocs );
}

export default mySaga;




// WEBPACK FOOTER //
// ./src/lib/sagas/list-docs.js